import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black shadow-lg' : 'bg-black'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-24 md:h-32">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/15751d3c669cdd9698a599d6adc6ce88.png" 
              alt="Papi's Paving Logo" 
              className="h-20 sm:h-24 md:h-32 w-auto"
            />
          </div>
          
          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white p-2 cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center justify-end flex-1 space-x-4 lg:space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-sm lg:text-base font-semibold text-white hover:text-white/80 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer px-3 lg:px-6 py-3 rounded-xl"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-sm lg:text-base font-semibold text-white hover:text-white/80 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer px-3 lg:px-6 py-3 rounded-xl"
            >
              About Us
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-sm lg:text-base font-semibold text-white hover:text-white/80 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer px-3 lg:px-6 py-3 rounded-xl"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('portfolio')}
              className="text-sm lg:text-base font-semibold text-white hover:text-white/80 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer px-3 lg:px-6 py-3 rounded-xl"
            >
              Portfolio
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-sm lg:text-base font-semibold text-white hover:text-white/80 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer px-3 lg:px-6 py-3 rounded-xl"
            >
              Testimonials
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-green-600 text-white px-4 lg:px-8 py-3 lg:py-3.5 rounded-xl text-sm lg:text-base font-bold hover:bg-green-700 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Get a Quote
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black border-t border-white/10 py-4">
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-base font-semibold text-white hover:text-white/80 transition-all whitespace-nowrap cursor-pointer px-4 py-3 text-left"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-base font-semibold text-white hover:text-white/80 transition-all whitespace-nowrap cursor-pointer px-4 py-3 text-left"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-base font-semibold text-white hover:text-white/80 transition-all whitespace-nowrap cursor-pointer px-4 py-3 text-left"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="text-base font-semibold text-white hover:text-white/80 transition-all whitespace-nowrap cursor-pointer px-4 py-3 text-left"
              >
                Portfolio
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-base font-semibold text-white hover:text-white/80 transition-all whitespace-nowrap cursor-pointer px-4 py-3 text-left"
              >
                Testimonials
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-green-600 text-white px-4 py-3 rounded-xl text-base font-bold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer shadow-lg mx-4 mt-2"
              >
                Get a Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}